import React from "react";
import { Table, Button, Row, Col } from "antd";
import moment from "moment";
import useStockItemContext from "../../../hooks/useStockItemContext";
import { useSelector, useDispatch } from "react-redux";
import { Creators as StockItemActions } from "../../../store/ducks/stockItem";
import { numberMask } from "../../../services/helpersMethodsService";
import {
  TagStatusActive,
  TagStatusInactive,
} from "../../../components/utils/tagStatus";
import ExcelExportButton from "../../../components/utils/excelExportButton";

const StockItemTable = () => {
  const { translation } = useSelector((state) => state.app);
  const tStatus = translation?.status || {};
  const t = translation?.stockItem?.table || {};

  const {
    data,
    isLoading,
    pagination,
    searchTerm,
    showInactive,
    handleOpenDetail,
    groupId,
    farmId,
  } = useStockItemContext();

  const dispatch = useDispatch();

  const items = Array.isArray(data) ? data : [];

  const filtered = items
    .filter((item) => (showInactive ? !item.active : item.active))
    .filter((item) => {
      if (!searchTerm) return true;
      const term = searchTerm.toLowerCase();
      return (
        (item.internalId || "").toLowerCase().includes(term) ||
        (item.abbreviation || "").toLowerCase().includes(term) ||
        (item.description || "").toLowerCase().includes(term)
      );
    });

  const columns = [
    {
      title: t.status || "Status",
      dataIndex: "status",
      key: "status",
      render: (_, record) => {
        switch (record.status) {
          case "Active":
            return <TagStatusActive>{tStatus.active}</TagStatusActive>;
          default:
            return <TagStatusInactive>{tStatus.inactive}</TagStatusInactive>;
        }
      },
    },
    {
      title: t.internalId || "Identificação",
      dataIndex: "internalId",
      key: "internalId",
    },
    {
      title: "!",
      key: "audit",
      width: 30,
      render: (_, record) =>
        record.hasPendingAudit ? (
          <span style={{ color: "red", fontWeight: "bold" }}>!</span>
        ) : null,
    },
    {
      title: t.abbreviation || "Abrev",
      dataIndex: "abbreviation",
      key: "abbreviation",
    },
    {
      title: t.group || "Grupo",
      dataIndex: "groupItem",
      key: "groupItem",
    },
    {
      title: t.subgroup || "Subgrupo",
      dataIndex: "itemGroup",
      key: "itemGroup",
    },
    {
      title: t.currentQty || "Qtd Atual",
      dataIndex: "currentQty",
      key: "currentQty",
      align: "right",
      render: (val) =>
        val != null ? numberMask(val, false, null, null, 4, 4) : "-",
      onCell: (record) => ({
        style:
          (record.currentQty || 0) <= (record.replenishmentPoint || 0)
            ? { backgroundColor: "#fffbe6" }
            : {},
      }),
    },
    {
      title: t.unit || "Unidade",
      dataIndex: "measurementUnitName",
      key: "measurementUnitName",
    },
    {
      title: t.replenishmentPoint || "Pto Repos.",
      dataIndex: "replenishmentPoint",
      key: "replenishmentPoint",
      align: "right",
      render: (val) => (val != null ? numberMask(val, false) : "-"),
    },
    {
      title: t.currentCost || "Custo Atual",
      dataIndex: "currentCost",
      key: "currentCost",
      align: "right",
      render: (val) => numberMask(val, true, null, null, 5, 5),
    },
    {
      title: t.actions || "Ações",
      key: "actions",
      width: 60,
      align: "center",
      render: (_, record) => (
        <Button
          size="small"
          icon="eye"
          onClick={() => handleOpenDetail(record)}
        />
      ),
    },
  ];

  const handleTableChange = (paginationInfo) => {
    dispatch(
      StockItemActions.changeStockPagination(
        paginationInfo.current - 1,
        paginationInfo.pageSize,
      ),
    );
    // dispatch(
    //   StockItemActions.indexStockItem(
    //     groupId,
    //     farmId,
    //     paginationInfo.current - 1,
    //     paginationInfo.pageSize,
    //   ),
    // );
  };

  const exportColumns = {
    status: tStatus.title || "Status",
    internalId: t.internalId || "Identificação",
    abbreviation: t.abbreviation || "Abrev",
    groupItem: t.group || "Grupo",
    itemGroup: t.subgroup || "Subgrupo",
    currentQty: t.currentQty || "Qtd Atual",
    measurementUnitName: t.unit || "Unidade",
    replenishmentPoint: t.replenishmentPoint || "Pto Repos.",
    currentCost: t.currentCost || "Custo Atual",
    hasVariant: t.has_variant || "Tem Variante",
    batchControl: t.batch_control || "Controle de Lote",
    hasMovement: t.has_movement || "Tem Movimentação",
  };

  const exportFilters = [
    {
      field: "groupItem",
      label: t.group || "Grupo",
      type: "String",
      operator: "LIKE",
    },
    {
      field: "itemGroup",
      label: t.subgroup || "Subgrupo",
      type: "String",
      operator: "LIKE",
    },
  ];

  return (
    <>
      <Row type="flex" justify="start" style={{ marginBottom: 8 }}>
        <Col>
          <ExcelExportButton
            columns={exportColumns}
            filters={exportFilters}
            reportName="StockItem"
            fileName={`Listagem_ItensEstoque_${moment().format("DDMMYYYY")}`}
          />
        </Col>
      </Row>
      <Table
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={filtered}
        size="small"
        onChange={handleTableChange}
        pagination={{
          current: (pagination?.page || 0) + 1,
          pageSize: pagination?.size || 15,
          total: pagination?.total || filtered.length,
          showSizeChanger: true,
          pageSizeOptions: ["15", "30", "50", "100"],
        }}
      />
    </>
  );
};

export default StockItemTable;
